import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'HomeView',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: "首页",
      keepAlive: true, // 需要缓存
    }
  },
  {
    path: '/college',
    name: 'college',
    component: () => import('@/views/college/index.vue'),
    meta: {
      title: "商学院",
      keepAlive: true, // 需要缓存
    }
  },
  {
    path: '/mine',
    name: 'MineView',
    component: () => import('@/views/mine/index.vue'),
    meta: {
      title: "我的",
      keepAlive: true, // 需要缓存
    }
  },
  {
    path: "/data",
    name: "Data",
    component: () => import("@/views/data"),
    meta: {
      title: "数据",
      keepAlive: true, // 需要缓存
    }
  },
  {
    path: '/materialShare',
    name: 'SocialMediaKit',
    component: () => import('@/views/mine/socialMediaKit.vue'),
    meta: {
      title: "发圈素材",
      keepAlive: true, // 需要缓存
    }
  },
  {
    path: '/goodsDetail',
    name: 'GoodsDetail',
    component: () => import('@/views/home/goodsDetail.vue'),
    meta: {
      title: "商品详情",
      keepAlive: true, // 需要缓存
    }
  },
  {
    path: '/submitOrder',
    name: 'SubmitOrder',
    component: () => import('@/views/home/submitOrder.vue'),
    meta: {
      title: "报单",
      keepAlive: true, // 需要缓存
    }
  },
  {
    path: '/buySuccess',
    name: 'BuySuccess',
    component: () => import('@/views/home/buySuccess.vue'),
    meta: {
      title: "订单详情",
    }
  },
  {
    path: '/message/list',
    name: 'MessageList',
    component: () => import('@/views/message/list.vue'),
    meta: {
      title: "消息列表",
      keepAlive: true, // 需要缓存
    }
  },
  {
    path: '/message',
    name: 'MessageView',
    component: () => import('@/views/message/message.vue'),
    meta: {
      title: "消息",
    }
  },
  {
    path: '/infoCollection',
    name: 'InfoCollection',
    component: () => import('@/views/home/infoCollection.vue'),
    meta: {
      title: "个人信息",
    }
  },
  {
    path: '/contactSupport',
    name: 'ContactSupport',
    component: () => import('@/views/mine/contactSupport.vue'),
    meta: {
      title: "联系客服",
    }
  },
  {
    path: '/settings',
    name: 'SettingsView',
    component: () => import('@/views/mine/settings.vue'),
    meta: {
      title: "设置",
    }
  },
  {
    path: '/myCustomer',
    name: 'MyClients',
    component: () => import('@/views/mine/myClients.vue'),
    meta: {
      title: "我的客户",
    }
  },
  {
    path: '/addressList',
    name: 'ShippingAddress',
    component: () => import('@/views/mine/shippingAddress.vue'),
    meta: {
      title: "我的收货地址",
    }
  },
  {
    path: '/addShippingAddress',
    name: 'AddShippingAddress',
    component: () => import('@/views/mine/addShippingAddress.vue'),
    meta: {
      title: "添加收货地址",
    }
  },
  {
    path: '/companionship',
    name: 'CompanionBooking',
    component: () => import('@/views/mine/companionBooking.vue'),
    meta: {
      title: "陪伴预约",
      keepAlive: true, // 需要缓存
    }
  },
  {
    path: '/companionBooking2',
    name: 'CompanionBooking2',
    component: () => import('@/views/mine/companionBooking2.vue'),
    meta: {
      title: "陪伴预约",
    }
  },
  {
    path: '/shippingAddressSelect',
    name: 'ShippingAddressSelect',
    component: () => import('@/views/home/shippingAddressSelect.vue'),
    meta: {
      title: "选择收货地址",
    }
  },
  {
    path: '/message/chat-list',
    name: 'ChatList',
    component: () => import('@/views/message/chat-list.vue'),
    meta: {
      title: "消息聊天",
    }
  },
  {
    path: '/inviteCustomer',
    name: 'inviteCustomer',
    component: () => import('../views/invite/inviteCustomer.vue'),
    meta: {
      title: "邀请客户",
    }
  },
  {
    path: '/invite',
    name: 'InvitePage',
    component: () => import('../views/invite/index.vue'),
    meta: {
      title: "邀请客户",
    }
  },
  {
    path: '/inviteKani',
    name: 'InviteKani',
    component: () => import('../views/invite/kani.vue'),
    meta: {
      title: "邀请客户",
    }
  },
  // 陪伴导师绑定
  {
    path: '/mentor',
    name: 'Mentor',
    component: () => import('../views/mentor/index.vue'),
    meta: {
      title: "陪伴导师绑定",
    }
  },
  {
    path: '/interest',
    name: 'InterestPage',
    component: () => import('../views/interest/index.vue'),
    meta: {
      title: "权益中心",
    }
  },
  // 商学院教程详情
  {
    path: '/collegeDetail',
    name: 'collegeDetail',
    component: () => import('@/views/college/collegeDetail.vue'),
    meta: {
      title: "商学院",
    }
  },
  // 用户协议
  {
    path: "/userProtocol",
    name: "UserProtocol",
    component: () => import("@/views/protocols/user.vue"),
    meta: {
      title: "用户协议",
    }
  },
  // 隐私协议
  {
    path: "/privacyProtocol",
    name: "PrivacyProtocol",
    component: () => import("@/views/protocols/privacy"),
    meta: {
      title: "隐私协议",
    }
  },
  // 用户协议-卡尼
  {
    path: "/userProtocolKani",
    name: "UserProtocolKani",
    component: () => import("@/views/protocolsAudit/kani/user.vue"),
    meta: {
      title: "用户协议",
    }
  },
  // 隐私协议-卡尼
  {
    path: "/privacyProtocolKani",
    name: "PrivacyProtocolKani",
    component: () => import("@/views/protocolsAudit/kani/privacy.vue"),
    meta: {
      title: "隐私协议",
    }
  },
  // 快速入口活动页
  {
    path: "/quickEnter",
    name: "QuickEnter",
    component: () => import("@/views/quickEnter"),
    meta: {
      title: "活动页",
    }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login"),
    meta: {
      title: "登录",
    }
  },
  {
    path: "/submitDetail",
    name: "submitDetail",
    component: () => import("@/views/data/dataSummary/submitDetail"),
    meta: {
      title: "上交明细",
    }
  },
  {
    path: "/rewardList",
    name: "rewardList",
    component: () => import("@/views/data/dataSummary/rewardList"),
    meta: {
      title: "奖励明细",
      keepAlive: true
    }
  },
  {
    path: "/rewardDetail",
    name: "rewardDetail",
    component: () => import("@/views/data/dataSummary/rewardDetail"),
    meta: {
      title: "奖励明细详情",
    }
  },
  {
    path: "/billDetail",
    name: "billDetail",
    component: () => import("@/views/data/dataSummary/billDetail"),
    meta: {
      title: "对账明细",
    }
  },

  // 评价导师
  {
    path: "/mentorEvaluation",
    name: "MentorEvaluation",
    component: () => import("@/views/mentorEvaluation/index.vue"),
    meta: {
      title: "评价导师",
    }
  },
  // 上传带教视频
  {
    path: "/uploadTeachingVideo",
    name: "UploadTeachingVideo",
    component: () => import("@/views/mentorEvaluation/uploadTeachingVideo.vue"),
    meta: {
      title: "上传带教视频",
    }
  },
  // 预约记录
  {
    path: "/appointmentRecords",
    name: "AppointmentRecords",
    component: () => import("@/views/appointmentRecords/index.vue"),
    meta: {
      title: "预约记录",
    }
  },
  // 搬贝中国行
  {
    path: "/activityZgx",
    name: "activityZgx",
    component: () => import("@/views/activityZgx"),
    meta: {
      title: "搬贝中国行，友推汇彩云",
    }
  },
  // 中华行活动页
  {
    path: "/zgxEntry",
    name: "zgxEntry",
    component: () => import("@/views/activityZgx/entry"),
    meta: {
      title: "中华行奖励",
    }
  },
  // 团队帮聊
  {
    path: "/activityTdbl",
    name: "activityTdbl",
    component: () => import("@/views/activityTdbl"),
    meta: {
      title: "团队帮聊",
    }
  },
  // 团队帮聊-提交帮聊
  {
    path: "/activityTdblSubmit",
    name: "activityTdblSubmit",
    component: () => import("@/views/activityTdbl/submit.vue"),
    meta: {
      title: "提交帮聊",
    }
  },
  {
    path: "/battles",
    name: "battleReport",
    component: () => import("@/views/mineFeature/battleReport/index.vue"),
    meta: {
      title: "战报数据",
    }
  },
  {
    path: "/accompanyTest",
    name: "accompanyTest",
    component: () => import("@/views/mineFeature/accompanyTest/index.vue"),
    meta: {
      title: "陪伴测试",
    }
  },
  {
    path: "/studentPoster",
    name: "studentPoster",
    component: () => import("@/views/mineFeature/accompanyTest/studentPoster.vue"),
    meta: {
      title: "学员喜报",
    }
  },
  {
    path: "/accompanyTeamReportPage",
    name: "accompanyTeamReportPage",
    component: () => import("@/views/mineFeature/teamReport/index.vue"),
    meta: {
      title: "学员喜报",
    }
  },
  {
    path: "/scheduleManagement",
    name: "scheduleManagement",
    component: () => import("@/views/mineFeature/scheduleManagement/index.vue"),
    meta: {
      title: "预约管理",
    }
  },
  // 年终活动页
  {
    path: "/yearEnd",
    name: "yearEnd",
    component: () => import("@/views/activityYearEnd"),
    meta: {
      title: "巅峰对决，年终王者之战",
    }
  },
  // 新人导师绑定
  {
    path: "/newMentorBinding",
    name: "newMentorBinding",
    component: () => import("@/views/newMentorBinding"),
    meta: {
      title: "新人导师绑定",
    }
  },
  // 陪伴导师
  {
    path: "/newComerPage",
    name: "newComerRunWith",
    component: () => import("@/views/newComerRunWith/classList.vue"),
    meta: {
      title: "新人陪跑",
      keepAlive: true, // 需要缓存
    }
  },
  // 学生列表
  {
    path: "/newComerPage/studentList",
    name: "NewComerRunWithStudentList",
    component: () => import("@/views/newComerRunWith/studentList.vue"),
    meta: {
      title: "学生列表",
      keepAlive: true, // 需要缓存
    }
  },

  // 新人陪跑-学员海报
  {
    path: "/novicePoster",
    name: "novicePoster",
    component: () => import("@/views/mineFeature/noviceAccompany/studentPoster.vue"),
    meta: {
      title: "学员海报",
    }
  },
  // 新人陪跑-排行榜
  {
    path: "/noviceRankList",
    name: "noviceRankList",
    component: () => import("@/views/mineFeature/noviceAccompany/rankList.vue"),
    meta: {
      title: "排行榜",
    }
  },

  // 大屏展示
  {
    path: "/largeScreen",
    name: "largeScreen",
    component: () => import("@/views/largeScreen/index.vue"),
    meta: {
      title: "大屏展示",
    }
  },
  // 直属业绩
  {
    path: "/subPerformance",
    name: "subPerformance",
    component: () => import("@/views/subPerformance/index.vue"),
    meta: {
      title: "直属业绩",
    }
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

export default router
